module.exports = __webpack_public_path__ + "img/DNA.e9c7a721.svg";